var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.category),function(item,index){return _c('div',{key:index},[_c('van-cell',{attrs:{"title":item,"is-link":""},on:{"click":function($event){return _vm.toContent(index)}}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }